import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';
import sicrediColor from 'assets/styles/default.scss';

export default makeStyles(
  (theme: Theme) =>
    createStyles({
      header: {
        display: 'flex',
        flexDirection: 'column',
        margin: theme.spacing(2, 0, 1),
      },
      totais: {
        marginTop: theme.spacing(1),
      },
      headline: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        marginBottom: theme.spacing(2),
      },
      backButton: {
        fontSize: 16,
        marginRight: theme.spacing(1),
        color: sicrediColor.primarySicredi,
        padding: 0,
      },
      info: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
        width: '100%',
      },
    }),
  { name: 'RelatorioPresentes' }
);
